import CompanyInfo from './CompanyInfo'
import GeneralInfo from './GeneralInfo'
import IndividualInfo from './IndividualInfo'
import cloneDeep from 'lodash/cloneDeep'
import { USER_TYPE_CUSTOMER_COMPANY, USER_TYPE_CUSTOMER_PERSON } from '@/constants/user/roles'
import Skill from '@/models-ts/Skill'
import Channel from '@/models-ts/user/Channel'
import PrefferedCurrency from '../../PrefferedCurrency'

export default class MyCustomerProfile {
  roleWasSet: Boolean
  generalInfo: GeneralInfo
  individualInfo: IndividualInfo
  companyInfo: CompanyInfo
  skills: Array<Skill>
  currencies: Array<PrefferedCurrency>
  channels: Array<Channel>
  type: typeof USER_TYPE_CUSTOMER_PERSON | typeof USER_TYPE_CUSTOMER_COMPANY

  constructor({
    roleWasSet = false,
    generalInfo,
    individualInfo,
    companyInfo,
    skills = [],
    currencies = [],
    channels = [],
    type = USER_TYPE_CUSTOMER_PERSON,
  }: Partial<MyCustomerProfile>) {
    Object.assign(this, cloneDeep({ roleWasSet, generalInfo, individualInfo, companyInfo, skills, currencies, channels, type }))
  }

  static fromServer(props: LX.MyCustomerProfile) {
    return new MyCustomerProfile({
      type: props.type,
      roleWasSet: props.first_save === 1,
      generalInfo: GeneralInfo.fromServer(props),
      individualInfo: IndividualInfo.fromServer(props),
      companyInfo: CompanyInfo.fromServer(props),
      skills: (props.relations.Skill || []).map(Skill.fromServer),
      channels: (props.relations.Channel || []).map(Channel.fromServer),
      currencies: (props.relations.Currency || []).map(PrefferedCurrency.getFromSrever).filter(Boolean) as Array<PrefferedCurrency>,
    })
  }
}
